import cx from 'classnames';
import React from 'react';
import { Tag } from '~/types/models/tags';
import TagListItem from './TagListItem';

interface TagListProps {
  tags: Tag[];
  className?: string;
  onTagNameChange?: (tag: Tag, name: string) => void;
  onDeleteClick?: (tag: Tag) => void;
}

export default function TagList({
  tags,
  className,
  onTagNameChange,
  onDeleteClick
}: TagListProps){

  return (
    <div className={cx(className, 'flex flex-col overflow-y-auto', 
    [
      'scrollbar-thin scrollbar-track-neutral-200 scrollbar-track-rounded-full',
      'scrollbar-thumb-neutral-400 scrollbar-thumb-rounded-full',
    ])}>
      {tags.map((tag)=> {
        return (
          <TagListItem 
            key={tag.uuid}
            tag={tag} 
            className="mb-5"
            onDeleteClick={() => onDeleteClick?.(tag)}
            onTagNameChange={onTagNameChange}
          />
        );
      })}
    </div>
  );
}